import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {RestService} from "../../core/services/rest.service";
import {VinculoAtividadeNacional} from '../../../classes/vinculo.atividade.nacional';
import {Atividade} from "../../../classes/atividade";

@Injectable()
export class VinculoAtividadeNacionalService {

  constructor(private restService: RestService){
  }

  listWithSuggest(): Observable<VinculoAtividadeNacional[]> {
    return this.restService.post("/vinculo-atividade-nacional/listWithSuggest", {responseType: VinculoAtividadeNacional});
  }

  vinculaAtividadeNacional(vinculosAtividadeNacional: VinculoAtividadeNacional[]) {
    return this.restService.post("/vinculo-atividade-nacional/vinculaAtividadeNacional", {data:vinculosAtividadeNacional, responseType: VinculoAtividadeNacional});
  }

  getAtividadeFromAtividadeNacional(atividadeNacional: number): Observable<Atividade> {
    return this.restService.get("/vinculo-atividade-nacional/atividade/"+ atividadeNacional, {responseType: Atividade});
  }

}
